import "./style.css";

function DashboardCard({ children, backgroundColor }) {
    return <div className="card" style={{ backgroundColor }}>{children}</div>
}

export default DashboardCard;